var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.775 16.94l5.391-5.303a.741.741 0 01.545-.226.782.782 0 01.554.242c.151.159.23.34.235.54a.711.711 0 01-.235.54l-6.612 6.505a.866.866 0 01-.309.203c-.108.04-.225.059-.35.059-.126 0-.243-.02-.351-.06a.866.866 0 01-.31-.202l-6.611-6.504a.728.728 0 01-.222-.528.76.76 0 01.222-.553.773.773 0 011.115 0l5.374 5.287V5.27a.763.763 0 01.782-.77.763.763 0 01.782.77v11.67z",
    fill: "currentColor"
  })));
}
SvgDown.displayName = 'Down';
export default SvgDown;